module.exports = __webpack_public_path__ + "static/media/xc-travel.3b2daaf426a89bd1091ca2e04655a219.png";